import { render, staticRenderFns } from "./HeaderBottomNavigation.vue?vue&type=template&id=902b7e8c&scoped=true&"
import script from "./HeaderBottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./HeaderBottomNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBottomNavigation.vue?vue&type=style&index=0&id=902b7e8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902b7e8c",
  null
  
)

export default component.exports